import { DecimalPipe } from '@angular/common'
import { Component, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { DashboardHomeService } from 'src/app/core/dashboard/dashboard-home.service'

@Component({
    selector: 'sf-dashboard-insights',
    imports: [DecimalPipe],
    templateUrl: './dashboard-insights.component.html',
    styleUrl: './dashboard-insights.component.scss',
})
export class DashboardInsightsComponent {
    dashboardService = inject(DashboardHomeService)

    dashboardStats = toSignal(this.dashboardService.getDashboardStats())
}
